//import liraries
import React, { useEffect, useState, useRef } from "react";
import { View, Text, TouchableOpacity, Image } from 'react-native';
import CHeader from "../../common/CHeader";
import MainContainer from "../../common/CWrapper";
import CText from "../../common/CText";
import { disputeDropdown, raiseDispute } from "../../api/apiManager";
import CustomButton from "../../common/CustomButton";
import { COLORS, FONTS } from "../../constant";
import CDropdown from "../../common/CDropdown";
import CustomInput from "../../common/CustomInput";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";
import CCheckbox from "../../common/CCheckBox";
import CImage from "../../common/CImage";
import DuplicateDisputeLList from './DupliccateDisputeList.web'
import { headingData } from "../../constant/dataHelper";
import CView from "./CView";
import ChooseImage from "./ChooseImage";
import { isEmpty } from "lodash";
import CTable from "./CTable";
import useStyles from "./CreateRaiseDispute_Styles";
import CDocxViewer from "../../common/CDocxViewer";
// create a component
const CreateRaiseDispute = (props) => {
  const transactionData = [props?.data?.disputeItem];
  const disputeDate = transactionData[0]?.dateTime
  const txnId = transactionData[0]?.transId
  const styles = useStyles();
  const [isLListUi, setIsListUi] = useState(false)
  const [duplicateDetails, setDuplicateDetails] = useState(false)
  const [isDuplicate, setIsDuplicate] = useState(false)
  const [loading, setLoading] = useState(false);
  const [frontfile, setFrontImage] = useState("");
  const [backImage, setBackImage] = useState();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [previewBackImage, setPreviewBackImage] = useState("");
  const [previewVDBackImage, setPreviewVDBackImage] = useState("");
  const [previewVDFrontImage, setPreviewVDFrontImage] = useState("");
  const [VDfrontfile, setVDFrontImage] = useState("");
  const [VDbackFile, setVDBacckFile] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [tncModalVisible, setTncModalVisible] = useState(false);
  const [previewFrontImage, setPreviewFrontImage] = useState("");
  const [originalTransId, setOriginalTransId] = useState("");
  const [data, setData] = useState("");
  const [disputeType, setDisputeType] = useState("");
  const [selectedReasonObj, setSelectedReasonObj] = useState({});
  const [disputeAmount, setDisputeAmount] = useState(props?.data?.disputeItem?.price);
  const [disputeRemarks, setDisputeRemarks] = useState("");
  const [debitAmontType, setDebitAmontType] = useState("Full Amount");
  const [correctFare, setCorrectFare] = useState("")
  const [errorMsg, setErrorMsg] = useState("Amount should not exceed Original Transaction")
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });
  const resetData = () =>{
    setCorrectFare("")
    setErrorMsg("Amount should not exceed Original Transaction")  
    setDuplicateDetails(false)
    clearImage("upload");
    clearImage("uploadBack")
    clearImage("VDuploadBack")
    clearImage("VDuploadFront")
  }
  const onCloseModal = () => {
    if (alertModal.navigateScreen == "home") {
      props.setScreen("home")
      setAlertModalVisible(false);
    } else {
      setAlertModalVisible(false);
    }
  };
  useEffect(() => {
    if (frontfile) {
      let reader = new FileReader();
      reader.onloadend = () => { setPreviewFrontImage(reader.result);};
      reader.readAsDataURL(frontfile);
    }
     if (backImage) {
      let reader = new FileReader();
      reader.onloadend = () => { setPreviewBackImage(reader.result); };
      reader.readAsDataURL(backImage);
    } 
     if (VDfrontfile) {
      let reader = new FileReader();
      reader.onloadend = () => {setPreviewVDFrontImage(reader.result);};
      reader.readAsDataURL(VDfrontfile);
    }
       if (VDbackFile) {
      let reader = new FileReader();
      reader.onloadend = () => { setPreviewVDBackImage(reader.result);};
      reader.readAsDataURL(VDbackFile);
    }
  }, [frontfile, backImage,VDbackFile,VDfrontfile]);

  const setImage = (id,file)=>{
    if(id == "upload"){
      clearImage("VDuploadFront")
      clearImage("VDuploadBack")
      setFrontImage(file);
    }else if(id == "uploadBack"){
      setBackImage(file)
      clearImage("VDuploadFront")
      clearImage("VDuploadBack")
    }else if(id == "VDuploadBack"){
      setVDBacckFile(file)
      clearImage("upload")
      clearImage("uploadBack")
    }else if(id == "VDuploadFront"){
      setVDFrontImage(file)
      clearImage("upload")
      clearImage("uploadBack")
    }
  }
  const clearImage = (id)=>{
    if(id == "upload"){
      setFrontImage("");
      setPreviewFrontImage("")
    }else if(id == "uploadBack"){
      setBackImage("")
      setPreviewBackImage("")
    }else if(id == "VDuploadBack"){
      setVDBacckFile("")
      setPreviewVDBackImage("")
    }else if(id == "VDuploadFront"){
      setVDFrontImage("")
      setPreviewVDFrontImage("")
    }
  }
  useEffect(() => {
    getDropDown();
  }, []);
  const getDropDown = () => {
    disputeDropdown()
      .then((res) => {
        setData({ getDisputeDropdown: res });
      })
      .catch(() => { });
  };
  const getDropDownData = (dropdown) => {
    if (
      dropdown &&
      dropdown.getDisputeDropdown &&
      dropdown.getDisputeDropdown.length > 0
    ) {
      let finalValue = [];
      dropdown.getDisputeDropdown.map((value) => {
        finalValue.push({
          label: value.reason,
          value: value.reason,
        });
      });
      if (disputeType == "") { setDisputeType(finalValue[0]);}
      return finalValue;
    } else {
      return [];
    }
  };

  const getObj = (reason) => {  
    let dropdown = data?.getDisputeDropdown;
    if(dropdown?.length > 0){
      let obj = []
      obj = dropdown.find((item)=>item.reason==reason)
      return obj
    }
  };

  const createReqObj = ()=>{
    let uploadPayload = new FormData();
    uploadPayload.append("vrn", props?.data?.disputeItem?.vrn + "");
    uploadPayload.append("transId", props?.data?.disputeItem?.transId + "");
    uploadPayload.append("tollPlaza", props?.data?.disputeItem?.tollPlaza + "");
    uploadPayload.append("price", props?.data?.disputeItem?.price + "");
    uploadPayload.append("dateTime", props?.data?.disputeItem?.dateTime + "");
    uploadPayload.append("location", props?.data?.disputeItem?.location + "");
    uploadPayload.append("statementType", props?.data?.disputeItem?.statementType + "");
    uploadPayload.append("amountType", debitAmontType);
    uploadPayload.append("disputeAmount", disputeAmount + "");
    uploadPayload.append("disputeType", disputeType + "");
    uploadPayload.append("disputeRemarks", disputeRemarks + "");
    uploadPayload.append("originalTransId", originalTransId + "");  
    uploadPayload.append("orgTxnDate",props?.data?.disputeItem?.orgDate + "");  
    uploadPayload.append("outletId",props?.data?.disputeItem?.outletId + "");
  if (previewFrontImage !== "" && frontfile) {
      uploadPayload.append("img1", frontfile);
  } else if (VDfrontfile) {
      uploadPayload.append("img1", VDfrontfile);
  }
  if (previewBackImage !== "" && backImage) {
      uploadPayload.append("img2", backImage);
  } else if (VDbackFile) {
      uploadPayload.append("img2", VDbackFile);
  }
    return uploadPayload
  }

  const onRaiseDispute = async () => {
    setLoading(true);
   let uploadPayload = await createReqObj()

    raiseDispute(uploadPayload)
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 1011 || res.statusCode == 1021) {
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res.message,
            navigateScreen: "home",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        } else if ( res.statusCode == -1023 || res.statusCode == -1022 || res.statusCode == 500) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        } else {
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (debitAmontType == "Full Amount") {
      setDisputeAmount(props?.data?.disputeItem?.price);
    }
  }, [debitAmontType,duplicateDetails]);

  const isButtonEnable = ()=>{
    if(isEmpty(selectedReasonObj )){
      return false
    }else if(!isChecked){return false }
    else{
      if([1,2,3,4,5].includes(selectedReasonObj.reqDocId)){ 
        if([2,3,4].includes(selectedReasonObj?.reqDocId)){
          if((previewVDBackImage && previewVDFrontImage) || (previewBackImage && previewFrontImage )){
            return true
          }
        }else{
          if( previewFrontImage){
            return true
          }
        }
      }else {
        if([6].includes(selectedReasonObj.reqDocId)){
          if(disputeRemarks){
            return true
          }
        }else return true
      }
    }
  }
  const validateFare = (val,price)=>{
    var regex = /^[0-9]+$/;
    if(regex.test(val)){
      if(val > 0 && val.length <=5){
        if(val <= parseInt(price)){
          setErrorMsg("")
          setCorrectFare(val)
        }else{
          setErrorMsg("Amount should not exceed Original Transaction")}
      }
    }else if(val==""){setCorrectFare(val)}
  }
  const renderTable = (header, details,isAction,isDuplicate)=>{
   return <CTable txnData={details} showActions = {isAction} isDuplicate={isDuplicate}/>
  }
  const renderDuplicateTransactionUi = () => {
    return (
      <>
        {duplicateDetails ? 
          <>
            <TouchableOpacity onPress={() => setIsListUi(true)} style={{ paddingLeft: 40 }}>
              <Text style={{ color: 'red', textDecorationLine: 'underline' }}>Change</Text>
            </TouchableOpacity>
            {renderTable({}, [duplicateDetails], false, true)}
          </> : <></>
        }
        <View style={styles.contentViewStyle}>
        <View style={styles.selectViewStyle}>           {!duplicateDetails && (
              <TouchableOpacity style={{ zIndex: 9 }} onPress={() => setIsListUi(true)}>
                <View style={{ ...styles.textInputStyle, flexDirection: 'row', justifyContent: 'space-around', height: 40 }}>
                  <CText.inputTopLabel>{'Select Transaction'}</CText.inputTopLabel>
                  <CImage.RightArrowSmall />
                </View>
              </TouchableOpacity>
            )}
            {![2].includes(selectedReasonObj.reasonId) ? (
              duplicateDetails ?
                  <View style={{ zIndex: 9 }}>
                    <CustomInput
                      label={'Amount to be Refunded or the Excess amount charged'}
                      value={`${correctFare}`}
                      onValueChanged={(t) => {
                        validateFare(t, duplicateDetails?.price);
                      }}
                      style={{ width: 290 }}
                      flexDirection={'column'}
                      mandatoryField={true}
                      editable={true}
                      type='number'
                      patternDif={/^\d{6}$/}
                      errorMessage={errorMsg}
                    />
                    <CText.inputError>{errorMsg} </CText.inputError>
                  </View> : <></>
            ) : (<></>
            )}
          </View>
          
          <View style={styles.selectViewStyle}>
            <View style={{ zIndex: 8 }}></View>
            <CText.usedCarLoanUpto>{'Kindly raise the dispute on your second transaction and provide transaction details of first journey to raise the issue.'}</CText.usedCarLoanUpto>
            <View style={styles.checkBoxViewStyle}>
              <CCheckbox
                termsText={'I agree to '}
                TermsAndCondition={'terms and conditions'}
                onPress={() => setTncModalVisible(true)}
                setIsTermsChecked={setIsChecked}
                isTermsChecked={isChecked}
              />
            </View>
            <View style={{ width: 170, height: 40, marginTop: 30 }}>
              {[2].includes(selectedReasonObj.reasonId) ? 
                <CustomButton
                  text={'Submit'}
                  disable={!duplicateDetails || !isChecked}
                  onPress={() => {
                    duplicateDetails && isChecked ? onRaiseDispute() : () => {};
                  }}
                />
               : 
                <CustomButton
                  text={'Submit'}
                  disable={!duplicateDetails || !isChecked || !correctFare}
                  onPress={() => {
                    duplicateDetails && isChecked && correctFare ? onRaiseDispute() : () => {};
                  }}
                />
              }
            </View>
          </View>
        </View>
      </>
    );
  };

  const renderUploadVehicleImage = (titleText,frontId,backId,img1,img2, preview1, preview2)=>{
    let uploadTitle = `Upload  ${titleText}`
    let uploadsubTitle = `Please ensure image size is ${global?.maxUploadFileSizeInMB}MB max`
    if(disputeType == "Wrong debit adjustment" || disputeType == "Excess Amount Charged"){
      uploadsubTitle = "Please ensure each image size is min 100 KB and max 2.5MB "
    }
    return  <>
    <View  style= {styles.uploadImageTitle}>
      <CText.warningHeader>{uploadTitle}</CText.warningHeader>
      <CText.inputTopLabel>{uploadsubTitle}</CText.inputTopLabel>
    </View>
    < View style= {styles.uploadImageWidget}>
    <ChooseImage 
      id={frontId}
      header = {{title:uploadTitle,subTitle:uploadsubTitle}}
      setImage = {setImage}
      onCancel={clearImage} setAlertModal={setAlertModal}
      label={"Add Front Image"} setAlertModalVisible={setAlertModalVisible}
      imageData = {{img:img1,preview:preview1}}
      />
   <ChooseImage id={backId}
      setImage = {setImage} setAlertModal={setAlertModal}
      onCancel={clearImage} setAlertModalVisible={setAlertModalVisible}
      label={"Add Back Image"} imageData = {{img:img2,preview:preview2}}/>
    </View></>
  }
  const renderImages = () => {
    return ( <>
            <View> {renderUploadVehicleImage(selectedReasonObj?.reqDoc,"upload","uploadBack",frontfile,backImage,previewFrontImage,previewBackImage)}</View>
            {[2,3].includes(selectedReasonObj?.reqDocId) ? (
              <>
                <View style={{ marginTop: 60 }}>
                  <Text>OR</Text>
                </View>
                <View style={{ marginTop: 20,minWidth:290  }}> {renderUploadVehicleImage('Upload font and back image of vehicle with number plate clearly visible',"VDuploadFront","VDuploadBack",VDfrontfile,VDbackFile,previewVDFrontImage,previewVDBackImage)}</View>
              </>
            ) : (
              <></>
            )}</>);
  };
  return (
    <MainContainer height={'auto'} paddingBottom={60} paddingTop={0} marginTop>
      {isLListUi ?
        <DuplicateDisputeLList setDuplicateDetails = {setDuplicateDetails} setIsListUi={setIsListUi} date={disputeDate}  txnId = {txnId} reasonID = {selectedReasonObj?.reasonId} amount = {transactionData[0]  ?.price} vrn={transactionData[0]?.vrn} duplicateDisute = {true} /> :
        <CView W100 H100 >
          <CHeader showBack  disputeHeader title='Raise a Dispute' onPress={() => props.setScreen('DisputeTransactions')} showDesc={true}/>
          {renderTable(headingData,transactionData,false)}
          <View style={styles.contentViewStyle}>
          <CView W50>
            <CView Z9>
              <CustomInput
                label={'Vehicle no.'}
                value={`${transactionData[0]?.vrn}`}
                onValueChanged={()=>{}}
                style={{ width: 290, backgroundColor: COLORS.lightGrayOp20, borderColor: COLORS.gray350 }}
                flexDirection={'column'}
                mandatoryField={true}
                editable={false}
              />
            </CView>
            <CView Z9>
              <CDropdown
                label='Reason for dispute'
                value={disputeType}
                onSelect={(value) => {
                  resetData()
                  setDisputeType(value)
                  setSelectedReasonObj(getObj(value))
                  if([5,4,2].includes(getObj(value)?.reasonId)){setIsDuplicate(true)}else{setIsDuplicate(false)}}}
                items={getDropDownData(data)}
                customStyle={{ width: 290 }}
                mandatoryField={true}
                lengthValue={25}
              />
          </CView>
          <View style={styles.infoWrapper}>
              <CImage.IconTip />
              <CView width={80}>
                <Text style={styles.disputeText}>{disputeType?.length > 0 ? disputeType : ''}</Text>
              </CView>
          </View>
          </CView>
          <View style={styles.disputeWrapper}>
          <View style={{ zIndex: 8 }}>
            <CustomInput
                label={'Transaction Amount'}
                value={`${disputeAmount}`}
                onValueChanged={()=>{}}
                style={{ width: 290 }}
                flexDirection={'column'}
                mandatoryField={true}
                pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
                editable={false}
            />
            {[6,7,8].includes(selectedReasonObj?.reasonId) ? 
             <>
             <CustomInput
                label = {selectedReasonObj?.reasonId == 8 ? "Amount Paid in Cash" :"Amount to be Refunded or the Excess amount charged"}
                value={`${correctFare}`}
                onValueChanged={(t)=>{validateFare(t,disputeAmount)}}
                style={{ width: 290}}
                flexDirection={'column'}
                mandatoryField={true}
                editable={true}  type="number"   patternDif={/^\d{6}$/} errorMessage={errorMsg}
              />
              <CText.inputError>{errorMsg} </CText.inputError>
              </>:<></>}
            </View>
            {[1,2,3,4,5,6].includes(selectedReasonObj?.reqDocId) ? renderImages() : <></>}
            {[6].includes(selectedReasonObj?.reqDocId) ?
              <CustomInput
              label={"Remarks"}
              value={disputeRemarks}
              onValueChanged={(t) => setDisputeRemarks(t)}
              flexDirection={"column"}
              multiline={true}
              style={{height: 90}}
              mandatoryField={true}
              maxLength={255}
            />   : <></>}
             {(!isDuplicate) ? <>
            <View style={styles.checkBoxViewStyle}>
              <CCheckbox termsText={'I agree to '} TermsAndCondition={'terms and conditions'} onPress={() => setTncModalVisible(true)} setIsTermsChecked={setIsChecked} isTermsChecked={isChecked} />
            </View>
            {[6, 7,8, 2,4,5].includes(selectedReasonObj?.reasonId) ?
            <View style={{ width: 170, height: 40, marginTop: 30 }}>
              <CustomButton text={'Submit'} disable={!(isButtonEnable()) || !correctFare} onPress={ () =>{ (isButtonEnable() && correctFare) ? onRaiseDispute() :()=>{}} } />
            </View>
             :
            <View style={{ width: 170, height: 40, marginTop: 30 }}>
                <CustomButton text={'Submit'} disable={!(isButtonEnable())} onPress={ () =>{ (isButtonEnable()) ? onRaiseDispute() :()=>{}} } />
            </View> }
            </> : <></>}
          </View>
          </View>
          <View style={{marginTop: 60 }}> 
            {isDuplicate ?  renderDuplicateTransactionUi() : <></>}
          </View>
        </CView>
      }
       {loading ? <Loader /> :<></>}
      {alertModalVisible ? 
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={'OK'}
            onCloseModal={onCloseModal}
          />
        </View>: <></>}
      {tncModalVisible ? <CDocxViewer  type = {"FF_TNC"}visibility={setTncModalVisible}/> :<></>}
    </MainContainer>
  );};
export default CreateRaiseDispute;
